import { User } from "@/types/user";
import { Schedule } from "./branch";

export enum ContentStatus {
  DRAFT = "draft",
  PUBLISHED = "published",
  ARCHIVED = "archived",
}

export enum SettingType {
  NUMBER = "number",
  OPTIONS = "options",
}

export enum ContentType {
  DISH = "dish",
  OFFER = "offer",
}

export interface Image {
  title: string;
  size: string;
  src: string;
}

export interface Option {
  id: string;
  title: string;
  price?: number;
  type: "option" | "subtitle";
}
export interface OptionDivider {
  id: string;
  title: string;
  subTitle: string;
}

export interface NewSetting {
  title: string;
  type: SettingType;
  min?: number;
  max?: number;
  options?: Option[];
  createdBy: string;
  createdAt?: string;
}

export interface Setting {
  id: string;
  title: string;
  type: SettingType;
  min: number;
  max: number;
  options?: Option[];
  createdBy?: string;
  createdAt?: number;
  lastUpdatedBy?: string;
  lastUpdatedAt?: number;
  defaultOption?: Option["id"];
  isAvailable?: boolean;
}

export interface BranchSettings {
  isDisabled?: boolean;
}

export type SettingAnswers = Record<Setting["id"], Setting["title"][]>;

export interface DraftContent {
  title: string;
  previewDescription?: string;
  description: string;
  price: number;
  images: string[];
  category: string;
  elements: string[];
  status: ContentStatus;
  settings?: Setting[] | SettingAnswers;
  order?: number;
  branchSettings?: BranchSettings;
}

export interface NewContent extends DraftContent {
  createdBy: string;
  createdAt: number;
}

export interface Content {
  id: string;
  title: string;
  previewDescription?: string;
  description: string;
  price: number;
  startingPrice?: number;
  images: string[];
  category: string[];
  elements: string[];
  createdBy: string;
  createdAt?: number;
  status: ContentStatus;
  settings?: Setting[] | SettingAnswers;
  time?: number;
  quantity?: number;
  available?: boolean;
  lastUpdatedBy?: User["uid"];
  lastUpdatedAt?: number;
  order?: number;
  type?: ContentType;
  isDisabled?: boolean;
  extras?: string[];
  schedule?: Schedule;
  branchSettings?: BranchSettings;
  loyalty?: {
    discountPct: ReactNode;
    pointsCost: number;       // Puntos necesarios
    isRedeemable: boolean;    // ¿Habilitado para canje?
    hideFromMenu?: boolean;   // ¿Ocultar de la carta pública?
    rewardType?: "item" | "discount_pct" | "discount_fixed"; 
    rewardValue?: number;     // Valor del descuento si aplica
  };
}

export interface Offer {
  id: string;
  title: string;
  images: string[];
  status: string;
  order?: number;
  region?: string;
  dishes?: [];
  disscount?: string;
  price?: number;
  startDate?: number;
  endDate?: number;
  type?: ContentType.OFFER;
  lastUpdatedBy?: User["uid"];
  lastUpdatedAt?: number;
  component?: "image" | "popup";
}

export interface NewOffer {
  title: string;
  images: string[];
  status: ContentStatus;
  createdBy: User["uid"];
  createdAt: number;
  type?: ContentType.OFFER;
  region?: string;
  component?: "image" | "popup";
}
